import type { FC, ReactNode } from 'react'
import React from 'react'
import { Button } from '../../common/Button/Button'
import { ModalBox } from '../../partials/ModalBox'
import type { Props as ModalBoxProps } from '../../partials/ModalBox/types'

type Props = {
  title: string
  text?: ReactNode
  confirmLabel?: string | false
  topContent?: ReactNode
  size?: ModalBoxProps['size']
  maxWidth?: number
  loading?: boolean
  onConfirm?: () => void
  close: () => void
}

export const AlertModal: FC<Props> = ({
  title,
  text,
  confirmLabel = 'Close',
  topContent,
  size,
  maxWidth,
  loading = false,
  onConfirm,
  close,
}) => {
  const handleConfirm = () => {
    // NOTE: to allow opening different modals in onConfirm we have to call close before it
    close()

    if (onConfirm) {
      onConfirm()
    }
  }

  return (
    <ModalBox
      title={title}
      topContent={topContent}
      buttons={
        confirmLabel
          ? [<Button label={confirmLabel} appearance="primary" onClick={handleConfirm} />]
          : undefined
      }
      size={size}
      maxWidth={maxWidth}
      loading={loading}
      onClose={close}
    >
      {text}
    </ModalBox>
  )
}
